<template>
<section>
    <section
        ref="rbRadioGroup"
        class="rounded-md flex items-center px-1 py-1 w-min bg-white dark:bg-inputBackground rb-radio-group">
        <template v-for="option in localOptions" :key="option.value">
            <div
                class="rounded-[5px] whitespace-nowrap cursor-pointer flex items-center justify-center"
                :class="[...buttonCLass, getButtonClass(option)]"
                @click="updateValue(option.value)">
                <n-icon
                    v-if="option?.icon"
                    class="text-base mr-2"
                    :class="option.icon?.classes">
                    <component :is="option.icon?.name" />
                </n-icon>
                {{ option.label }}
            </div>
        </template>
    </section>
</section>
</template>

<script>
// general
import general from './general';

// naive-ui
import {
    NIcon,
    NRadioGroup,
    NRadioButton } from 'naive-ui';

export default {
    name: 'rb-radio-group-mobile',
    props: {
        value: {
            type: [String, Number],
            required: true,
        },
        options: {
            type: Array,
            required: true,
        },
        size: {
            type: String,
            default: 'medium',
        },
        loading: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        NIcon,
        NRadioGroup,
        NRadioButton,
    },
    setup(props, context) {
    
        return {
            ...general(...arguments),
        };
    },
};
</script>

<style lang="scss" scoped>
:deep(.n-radio-group__splitor) {
    display: none;
}

:deep(.n-radio-button__state-border) {
    box-shadow: none !important;
}

:deep(.n-radio-button) {
    height: 80% !important;
    display: flex;
    align-items: center;
    margin-top: 0 !important;

    & .n-radio__label {
        margin-top: -1px;
        line-height: normal !important;
    }
}
</style>